import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Register.css";
import logo from "../assets/a0b9f44cc8f2da963034bf8a0849385a074bd917.png";
import Swal from "sweetalert2";


const Register: React.FC = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    full_name: "",
    mobile_number: "",
    email: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
  
    try {
      const response = await fetch(
        "https://www.crm.brickfolio.in/api/user-register",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            full_name: form.full_name,
            mobile_number: form.mobile_number,
            email: form.email,
          }),
        }
      );
  
      const data = await response.json();
      console.log("API Response:", data);
  
      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Registered Successfully",
          text: "Welcome to Brickfolio!",
          showConfirmButton: false,
          timer: 2000,
        });
  
        setTimeout(() => {
          navigate("/");
        }, 2000);
  
      } else {
        Swal.fire({
          icon: "error",
          title: "Registration Failed",
          text: data.message || "Something went wrong!",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Please try again later.",
      });
    }
  
    setLoading(false);
  };
  

  return (
    <div className="reg-wrapper">
      <div className="reg-card">
        <img src={logo} className="reg-logo" alt="logo" />

        <h2 className="reg-title">Create Account</h2>
        <p className="reg-sub">Join us today</p>

        <form onSubmit={handleSubmit}>
          <label>Full Name</label>
          <input
            type="text"
            name="full_name"
            placeholder="Enter your name"
            value={form.full_name}
            onChange={handleChange}
          />

          <label>Phone Number</label>
          <input
            type="text"
            name="mobile_number"
            placeholder="+91 98765 43210"
            value={form.mobile_number}
            onChange={handleChange}
          />

          <label>Email Address</label>
          <input
            type="email"
            name="email"
            placeholder="your.email@example.com"
            value={form.email}
            onChange={handleChange}
          />

          <button className="reg-btn" type="submit" disabled={loading}>
            {loading ? "Please wait..." : "Continue"}
          </button>
        </form>

        <p className="login-text">
          Already have an account?{" "}
          <span className="link" onClick={() => navigate("/")}>
            Login
          </span>
        </p>
      </div>
    </div>
  );
};

export default Register;
